export class CampaignData {
  id?: string;
  source?: string;
  'url_id'?: string;
}
